module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t2-5.4c125dbd.svg";